// extracted by mini-css-extract-plugin
module.exports =  {"preformatted":"s6lNx3jLCW8JWZm6CM0e"};